import { useMemo } from 'react';

import { useListContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterContextProvider } from 'shared/mui/Filter/context/filterContext';
import {
  FilterApplyButton,
  FilterButton,
  FilterClearButton,
  FilterResetButton,
} from 'shared/mui/Filter/FilterButtons';
import { FilterColumnsButton } from 'shared/mui/Filter/FilterButtons';
import { FilterChipsToolbar } from 'shared/mui/Filter/FilterChipsToolbar/FilterChipsToolbar';
import {
  FilterDrawer,
  FilterDrawerActionsButtons,
  FilterDrawerContent,
} from 'shared/mui/Filter/FilterDrawer';
import { FilterToolbar } from 'shared/mui/Filter/FilterToolbar/FilterToolbar';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { cleanEmpty } from 'utils/cleanEmpty';

import { CommissionsListDatagrid } from './CommissionsListDatagrid/CommissionsListDatagrid';
import {
  CommissionsListFilter,
  CommissionsListFilterFormValues,
} from './CommissionsListFilter/CommissionsListFilter';
import { CommissionsListFilterChips } from './CommissionsListFilterChips/CommissionsListFilterChips';

export const COMMISSIONS_PREFERENCE_KEY = 'commissions.list.datagrid';

const DEFAULT_FORM_VALUES: CommissionsListFilterFormValues = {
  name: null,
  status: [],
  merchant: null,
  provider: [],
  currency: [],
  transactionTypes: [],
  id: null,
  parent: null,
};

export const CommissionsListContent = () => {
  const { filterValues, data } = useListContext();

  const { form, appliedFilters, setAppliedFilter, onSubmit, onReset, openDrawer, toggleDrawer } =
    useFilters<CommissionsListFilterFormValues>({
      defaultValues: {
        name: filterValues?.name ?? null,
        status: filterValues?.status ?? [],
        merchant: filterValues?.merchant ?? null,
        provider: filterValues?.provider ?? [],
        currency: filterValues?.currency ?? [],
        transactionTypes: filterValues?.transactionTypes ?? [],
        id: filterValues?.id ?? null,
        parent: filterValues?.parent ?? null,
      },
      resetValues: DEFAULT_FORM_VALUES,
    });

  const listFilters = useMemo(() => {
    return cleanEmpty(appliedFilters);
  }, [appliedFilters]);

  const isListFilterExist = Object.keys(listFilters).length > 0;

  return (
    <>
      <FilterToolbar
        leftActionsSlot={[
          <FilterButton key="filter" onClick={toggleDrawer(true)} />,
          <FilterColumnsButton
            disabled={!data?.length}
            key="select-column"
            preferenceKey={COMMISSIONS_PREFERENCE_KEY}
          />,
        ]}
      />
      <FilterDrawer onClose={toggleDrawer(false)} open={openDrawer}>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FilterDrawerContent>
              <CommissionsListFilter />
            </FilterDrawerContent>
            <FilterDrawerActionsButtons>
              <FilterResetButton label="Очистить" onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterDrawerActionsButtons>
          </form>
        </FormProvider>
      </FilterDrawer>
      <FilterChipsToolbar appliedFilters={appliedFilters}>
        <FilterContextProvider appliedFilters={appliedFilters} setAppliedFilter={setAppliedFilter}>
          <FormProvider {...form}>
            <CommissionsListFilterChips />
            <FilterClearButton
              key="clear"
              onClick={() => {
                onReset();
              }}
              visible={isListFilterExist}
            />
          </FormProvider>
        </FilterContextProvider>
      </FilterChipsToolbar>
      <FormProvider {...form}>
        <FilterContextProvider appliedFilters={appliedFilters} setAppliedFilter={setAppliedFilter}>
          <CommissionsListDatagrid />
        </FilterContextProvider>
      </FormProvider>
    </>
  );
};
